<template>
  <div class="about">
    <div class="aboutInner">

      <img class="logo2" :src="baseURL + websiteInfo.logo" alt="" />
      <div>
        <div class="BlockTit" style="margin-left: 100px;">菜单</div>
        <div class="menuList">

          <div @click="handleScroll(item.id, index, item.name)" v-for="(item, index) in titleList" :key="index">{{item.name}}</div>
        </div>
      </div>
      <div>
        <div class="BlockTit">
          友情链接</div>
        <div class="name" v-for="item in linkData" :key="item.linkName">
          <a :href="item.linkUrl" target="_blank">
            {{item.linkName}}
          </a>
        </div>
      </div>
      <div>
        <div class="BlockTit" style="margin-left: 60px;">联系信息</div>
        <div class="infoList">

          <div>地址：{{websiteInfo.address}}</div>
          <div>邮编：{{websiteInfo.postalCode}}</div>
          <div>总机：{{websiteInfo.callCenter}}</div>
        </div>
      </div>
      <div class="imgBox">
        <img class="qrImage" :src="baseURL + websiteInfo.qrImage" alt="" srcset="" />
      </div>

    </div>
    <div class="about_bottom">
      <div>版权所有：方圆标志认证集团有限公司 Copyright(©)www.cqm.cn|www.cqm.com.cn All Rights Reserved</div>
      <div>京ICP备13011523号-1 京公网安备11010802015095号</div>
    </div>
  </div>
</template>
<script>
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    getLinkData,
    fetchWebsiteInfo,
    fetchAllCategory
  } from '@/api/api'
  export default {
    data() {
      return {
        linkData: [],
        websiteInfo: {},
        baseURL: serverUrl.baseURL,
        // titleList: [{
        //     name: '首页',
        //     id: 'home'
        //   },
        //   {
        //     name: '应用市场',
        //     id: 'talent'
        //   },
        //   {
        //     name: '解决方案',
        //     id: 'zcInformation'
        //   },
        //   {
        //     name: '标识解析',
        //     id: 'safe'
        //   },
        //   {
        //     name: '关于我们',
        //     id: 'open'
        //   }
        // ],
        titleList: [],
      }
    },
    created() {
      this.getWebsiteInfo()
      this.getLink()
      this.getCategory()
    },
    methods: {
      getCategory() {
        fetchAllCategory().then(res => {
          this.titleList = res.data;
          this.titleList.unshift({
            name: '首页',
            id: 'home'
          })
          this.titleList.push({
            name: '关于我们',
            id: 'open'
          })
          console.log('footer',this.titleList)
        })
      },
      getLink() {
        getLinkData().then(res => {
          this.linkData = res.data
        })
      },
      handleScroll(id, index, name) {
        // this.activeIndex = index
        if (name) {
          localStorage.setItem('name', name)
        }
        var element = document.getElementById(id)
        if (!element) {
          this.$router.push({
            path: '/home',
            query: {
              id: id
            }
          })
        }
        this.scroll = element.id
        this.$emit('setScroll', this.scroll)
      },
      getWebsiteInfo() {
        fetchWebsiteInfo().then(res => {
          this.websiteInfo = res.data
        })
      },
    }
  }
</script>
<style scoped>
  .about {
    width: 100%;
    background: #001855;
  }

  .aboutInner {
    width: 100%;
    background: #002071;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 50px 10%;
    box-sizing: border-box;
  }

  .about_bottom {
    height: 100px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .about_bottom>div {
    margin: 8px 0;
  }

  .logo2 {
    height: 46px;
  }

  .menuList {
    width: 300px;
    display: flex;
    flex-wrap: wrap;
    margin-left: 100px;
  }

  .menuList>div {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 36px;
    width: 150px;
    cursor: pointer;
  }

  .infoList {
    margin-left: 60px;
  }

  .infoList>div {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 38px;
  }

  .BlockTit {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 36px;
  }

  .name {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #fff;
    line-height: 36px;
  }

  .name a {
    color: #fff;
  }

  .name a:hover {
    color: #fff;
  }

  .imgBox {
    text-align: end;
    width: 240px;
  }

  .qrImage {
    width: 120px;
    height: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue